// eslint-disable-next-line
const packageJson = require('../package.json');

export function checkForCode(method, PathString, props, body) {
  const requestInput = {
    method: method,
    headers: new Headers({
      'Content-Type': 'application/json',
      code: props.cookies.get('code'),
      viewType: window.viewType,
    }),
  };

  if (body !== null) {
    requestInput.body = body;
  }

  if (window.viewType === 'phone') {
    PathString = process.env.REACT_APP_MOBILE_BACKEND_URL + PathString;
    //PathString = 'https://pot-game.dyordanov.com' + PathString;
  }

  return fetch(PathString, requestInput)
    .then((res) => res.json())
    .then((data) => {
      if (data.status) {
        props.navigate(`/LoginJustGoogle`);
        return null;
      } else {
        return data;
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

export function getRoomId() {
  let url = window.location.href;

  let splitUrl = url.split('/');

  let lastElement = splitUrl[splitUrl.length - 1].split('?');

  let result = lastElement[0];

  return result;
}

export function androidBackButton(handleGoBackRoom) {
  //only when the device is ready can we use the cordova functionalities
  document.addEventListener('deviceready', onDeviceReady, false);

  function onDeviceReady() {
    // Register the event listener for the back button
    document.addEventListener('backbutton', onBackKeyDown, false);
  }

  // Handle the back button
  function onBackKeyDown(e) {
    e.preventDefault();
  }
}

export function saveCookie(props) {
  let urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get('code');

  if (code) {
    props.cookies.set('code', code);
    let url = new URL(window.location);

    url.searchParams.delete('code');
    if (window.viewType !== 'phone') {
      window.location = url;
    }
  }

  return code;
}

//done in index.js
//document.addEventListener('deviceready', initStore);

// export function initStore(props) {
//   /* global store */
//   if (!store) {
//     console.log('Store not available');
//     return;
//   }

//   console.log('store: ' + JSON.stringify(store));
//   console.log('window.store: ' + JSON.stringify(window.store));
//   console.log('window.cordova.store: ' + JSON.stringify(window.cordova.store));

//   /* global store */
//   store.register({
//     id: 'premiumStatus',
//     type: store.NON_CONSUMABLE,
//   });

//   store.error(function (error) {
//     console.log('ERROR ' + error.code + ': ' + error.message);
//   });

//   // ... MORE HERE SOON
//   store.when('premiumStatus').updated(refreshProductUI);

//   store.when('premiumStatus approved', function (p) {
//     p.verify();
//   });
//   store.when('premiumStatus verified', (p) => finishPurchase(p, props));

//   store.refresh();
// }

// // export function refreshLockedUI() {
// //   //i don't think we need this
// //   document.getElementById('locked').textContent =
// //       'Feature ' + window.localStorage.unlocked === 'YES' ? 'UNLOCKED! \o/' : 'locked :('
// // }

// // document.addEventListener('deviceready', refreshLockedUI);

// export function refreshProductUI(product) {
//   const info = product.loaded
//     ? `title: ${product.title}<br/>` +
//       `desc: ${product.description}<br/>` +
//       `price: ${product.price}<br/>`
//     : 'Retrieving info...';
//   const button = product.canPurchase
//     ? '<button onclick="purchasePremiumStatus()">Buy Now!</button>'
//     : '';
//   const el = document.getElementById('premiumStatus-purchase');
//   el.htmlContent = info + button;
// }

// export function purchasePremiumStatus() {
//   store.order('premiumStatus');
// }

// export function finishPurchase(p, props) {
//   // here we should call the change status function in the backend

//   // let body = JSON.stringify({
//   //   nickname: this.state.userNickname,
//   //   profilePicture: this.state.profilePicture,
//   // });

//   checkForCode(
//     'PUT',
//     `/api/users/${props.cookies.get('code')}/setPremiumUserStatus`,
//     props,
//     null
//   ).then((data) => {
//     console.log('purchase success message: ' + JSON.stringify(data.message));
//   });

//   //window.localStorage.unlocked = "YES";
//   // refreshLockedUI();

//   p.finish();
// }
